import { useMediaQuery } from 'react-responsive';

export const useResponsive = () => {
  const isMobile = useMediaQuery({ maxWidth: 480 });
  const isTablet = useMediaQuery({ minWidth: 481, maxWidth: 768 });
  const isDesktop = useMediaQuery({ minWidth: 769 });

  return {
    isMobile,
    isTablet,
    isDesktop
  };
}; 